import {mergeTo} from '#core/utils/config-utils.js';
import {buildAccountItemsFromConfig} from '#core/utils/intent-factory.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Account} from '../account.js';

import {myAccountDialogFactory} from './my-account-dialog.factory';

import PALETTE_SCHEMA from './my-account-dialog.palette-schema.yaml';

class MyAccountDialogFeature extends AbstractVisualFeature {
    get name() {
        return 'MyAccountDialog';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(myAccountDialogFactory(PALETTE), {
            MyAccount: {
                menuSections: buildAccountItemsFromConfig(ApplicationConfig.config.myAccountViewItems),
            },
        });
    }
}

export const MyAccountDialog = new MyAccountDialogFeature(Account);
